module.exports = __webpack_public_path__ + "static/media/Wave_Mobile.bff93262.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Wave_Mobile.png
// module id = 369
// module chunks = 0